import {useQuery} from '@tanstack/react-query'

import {getStoreDetails} from '@/lib/food/foodService'

export default function useStoreDetails(storeId: string | undefined) {
  return useQuery({
    queryKey: ['storeDetails', storeId],
    queryFn: storeId ? async ({signal}) => getStoreDetails({storeId, signal}) : skipToken,
    throwOnError: false,
  })
}
